import { useState, useMemo } from "react";
import PageHeader from "../components/PageHeader";
import { PORTFOLIO } from "../data/site";

const CATEGORIES = ["Tutti", "Stradale", "Civile", "Specialistici"];

export default function Portfolio() {
  const [filter, setFilter] = useState("Tutti");
  const items = useMemo(
    () => (filter === "Tutti" ? PORTFOLIO : PORTFOLIO.filter((p) => p.category === filter)),
    [filter]
  );

  return (
    <>
      <PageHeader
        eyebrow="Lavori realizzati"
        title="Cantieri. Persone. Risultati."
        description="Una selezione dei cantieri completati negli ultimi anni nei tre settori in cui operiamo."
      />

      <section data-reveal className="py-12 md:py-16 bg-white border-b border-neutral-200 sticky top-16 md:top-20 z-30">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-wrap gap-2">
          {CATEGORIES.map((c) => (
            <button
              key={c}
              onClick={() => setFilter(c)}
              data-testid={`filter-${c.toLowerCase()}`}
              className={`px-5 py-3 rounded-full font-display font-bold text-xs uppercase tracking-[0.15em] border transition-colors ${
                filter === c
                  ? "bg-[#0B1E3F] text-white border-[#0B1E3F]"
                  : "bg-white text-[#0B1E3F] border-neutral-300 hover:border-[#0B1E3F]"
              }`}
            >
              {c}
            </button>
          ))}
        </div>
      </section>

      <section data-reveal className="py-16 md:py-24 bg-[#F5F5F3]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-6 gap-4 md:gap-6">
          {items.map((p, i) => {
            const sizeClass =
              i % 5 === 0
                ? "md:col-span-4 md:row-span-2 aspect-[16/10] md:aspect-auto"
                : i % 5 === 1
                ? "md:col-span-2 aspect-[4/5]"
                : i % 5 === 2
                ? "md:col-span-2 aspect-[4/5]"
                : i % 5 === 3
                ? "md:col-span-3 aspect-[4/3]"
                : "md:col-span-3 aspect-[4/3]";

            return (
              <div
                key={p.id}
                data-testid={`portfolio-item-${p.id}`}
                className={`service-card group relative overflow-hidden bg-[#0B1E3F] rounded-2xl ${sizeClass}`}
              >
                <img src={p.image} alt={p.title} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0 service-card-overlay" />
                <div className="absolute top-5 right-5 bg-white px-3 py-1 rounded-full font-mono text-[11px] tracking-[0.2em] uppercase shadow-sm">
                  {p.category}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 text-white">
                  <div className="font-mono text-[11px] tracking-[0.25em] uppercase text-[#60A5FA] mb-2">
                    / {p.year}
                  </div>
                  <h3 className="font-display font-black uppercase tracking-tighter text-2xl md:text-3xl lg:text-4xl max-w-md">
                    {p.title}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>

        {items.length === 0 && (
          <div className="text-center py-16 text-neutral-500 font-mono text-sm uppercase tracking-[0.2em]">
            Nessun progetto in questa categoria.
          </div>
        )}
      </section>
    </>
  );
}
